module.exports = __webpack_public_path__ + "img/Пункция_кисты_Бейкера_0.0e77fde6.png";